export const passwordValidationRequirements = [
  'one lowercase character',
  'one special character',
  'one uppercase character',
  '8 character minimum',
  'one number',
];
